import { useMemo, useState } from 'react';
export function useQueue<T>(initValue: T[] = []) {
  const [queue, setQueue] = useState<T[]>(initValue);
  const enqueue = useMemo(() => (item: T) => {
    setQueue(prev => [...prev, item]);
  }, []);
  const dequeue = useMemo(() => () => {
    let res = null;
    setQueue(prev_0 => {
      const [first, ...rest] = prev_0;
      res = first;
      return rest;
    });
    return res;
  }, []);
  return {
    queue,
    enqueue,
    dequeue,
    get length() {
      return queue.length;
    },
    get first() {
      return queue[0];
    },
    get last() {
      return queue[queue.length - 1];
    }
  };
}